import React from 'react';
import PropTypes from 'prop-types';
import { Route, Switch } from 'react-router-dom';
import Typography from '@material-ui/core/Typography';
// import './AppTitleBar.scss';

const AppTitleBar = (props) => {
  const { sortedRoutes, routeService } = props;
  return (
    <Switch>
      {sortedRoutes.map((route) => {
        const children = routeService.getChildRoutes(route, props);
        return children.map(childRoute => (
          <Route
            path={childRoute.matchPath}
            key={childRoute.id || childRoute.path}
            render={() => (
              <Typography variant="h5">
                {childRoute.getPageTitle ? childRoute.getPageTitle(props) : (childRoute.pageTitle || childRoute.label)}
              </Typography>
            )}
          />
        ));
      })}
    </Switch>
  );
};

AppTitleBar.propTypes = {
  sortedRoutes: PropTypes.arrayOf(PropTypes.shape({})),
  authService: PropTypes.shape({
    acceptRoute: PropTypes.func.isRequired,
  }).isRequired,
  routeService: PropTypes.shape({
    getChildRoutes: PropTypes.func,
  }).isRequired,
};

AppTitleBar.defaultProps = {
  sortedRoutes: [],
};

export default AppTitleBar;
